const requestsMethods = {
  GET: 'get',
  PUT: 'put',
  POST: 'post',
};

export default requestsMethods;
